import functions from './functions.js';
import Slider from './Slider.js';
import {SimpleGuests, SimpleGuestsDefaults} from "./simple-guests.js";
import {FormGuide, FormGuideDefaults} from "./form-guide.js";
import lozad from 'lozad';

SimpleGuestsDefaults.infantsAge = 6;

$(function() {

    const language = functions.getLang();

    // ? $('#navbarTogglerMain').removeClass('navbar-dark').addClass('visible navbar-light')
    //         : $('#navbarTogglerMain').removeClass('visible navbar-light').addClass('navbar-dark');

    $('body').on('click', '.dropdown-menu', e => {
        e.stopPropagation();
    });

    // global datepicker init with automatic "dateTo" set if provided
    let displayDate = new Date('2019-06-01');
    let now = functions.cleanDate(new Date);
    if ( now > displayDate ) {
        displayDate = now;
    }

    $('.datepicker').each((i, elem) => {
        const $datepicker = $(elem);
        console.log($datepicker);
        const minDate = $datepicker.attr('data-min');
        const maxDate = $datepicker.attr('data-max');
        $datepicker.flatpickr({
            altFormat: "j.m.Y",
            dateFormat: "Y-m-d",

            maxDate: maxDate ? maxDate : null,
        });
        // to style clear toggler
        // $datepicker.on('change', e => requestAnimationFrame(() => $(e.target).parent().toggleClass('datepicker-value', !!e.target.value)));
    }); 



    $('.simple-guests').each((i, elem) => {
		elem._simpleGuests = new SimpleGuests(elem);
	});

    $('.form-guide').each((i, elem) => {
		new FormGuide(elem);
	});


    $($('#pills-tab').find('.nav-link')[0]).addClass('active');
    $($('#pills-tabContent').find('.tab-pane')[0]).addClass('show active');


    let $navMenu = $('#navbarTogglerMain');

    if ($navMenu.length)
    {
        let $links = $navMenu.find('.nav-link[href^="#"]');
        $links.on('click', function(e) {
            $('#navbarText').collapse('hide');
        })
    }


    if($('.body-type-details').length)
    {
        if (! $('.card-booking').length)
        {
            $('.social-network-section').remove();
            $('.contact.bg-secondary').remove();
        }
    }

   
    // window.animateobserver = lozad('.animate-text-right', {
    //     rootMargin: '-200px 20000px',
    //     loaded: el => {
    //         $(el).addClass('trigger');
    //     }
    // });
    // window.animateobserver.observe();


    /* gallery */
    const lg = {};
    window.showGallery = (index, id) => {
        index = +index || 0;
        if ( lg[id] ) {
            lg[id].index = index;
            lg[id].build(index);
        } else {
            let $elem = $('[data-images-' + id + ']');
            lg[id] = $elem.lightGallery({
                dynamic: true,
                thumbnail: true,
                toogleThumb: false,
                thumbWidth: 130,
                thumbMargin: 10,
                download: false,
                preload: 2,
                index: index,
                dynamicEl: JSON.parse($elem.attr('data-images-' + id))
            }).data('lightGallery');
        }
    };
    $('[data-gallery-id]').on('click', function (e) {
        e.preventDefault();
        let galleryId = $(this).attr('data-gallery-id');
        galleryId && showGallery($(this).attr('data-index'), galleryId);
    });
    // don't focus div with gallery
    $('[data-gallery-id]').on('focus', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        return false;
    });

    
    // menu links active
    const path = location.pathname.replace(/\/$/, '');
    $('.main-header [href], footer [href]').each((i, link) => {
        let href = link.getAttribute('href');
        if ( href && href != '#' ) {
            href = href.split('?')[0].replace(/\/$/, '');
            if ( path === href ) {
                $(link).addClass('active').closest('.nav-item').addClass('active');
            }
        }
    });

    $('.period-btn').on('click', function(e, ignore) {
        if (ignore) return;
        let $target = $(this);
        let period = $target.attr('data-period');
 
        $('[data-period="' + period + '"]').each((i, elem) => { 
            $(elem).trigger('click', [true]);
        });
    })

    var maxWidth = 0;
    var widestSpan = null;
    var $element;
    $(".collapse.navbar-collapse .nav-item").each(function(){
    $element = $(this);
        if($element.width() > maxWidth){
            maxWidth = $element.width();
            widestSpan = $element; 
        }
    });

    $(".collapse.navbar-collapse .nav-item").css('width', maxWidth).find('.nav-link').addClass('d-flex justify-content-center');

    // global tooltip init
    //('[data-toggle="tooltip"]').tooltip();

    // mobile menu handling
    // (() => {
    //     const $header = $('.main-header');
    //     const $collapser = $('#main-menu');

    //     // ensure navbar toggler also open closes main-menu
    //     $collapser
    //         .on('show.bs.collapse', () => {
    //             document.body.classList.add('modal-transition');
    //             document.body.classList.add('modal-active');
    //         })
    //         .on('hide.bs.collapse', () => {
    //             document.body.classList.remove('modal-active');
    //         })
    //         .on('hidden.bs.collapse', () => {
    //             document.body.classList.remove('modal-transition');
    //         });

    //     // click on "overlay" closes menu
    //     $header.find('.header-overlay').on('click', () => {
    //         $collapser.collapse('hide');
    //     });
    // })();

    // scrool to element handling
    $(document).on('click', '[data-scroll-to]', e => {
        e.preventDefault();
        const $this = $(e.target);
        let scrollTo = $this.attr('data-scroll-to').split(',');
        functions.scrollToElement(scrollTo[0], scrollTo[1] || 0);
    });
    


    // select2 templates can be defined as data-template="destinations" ...
    const selectTemplates = {
        destinations: data => {
            if ( !data.element ) {
                return data.text;
            }
            if(data.placeId && data.placeName) {
                //const $element = $(data.element).addClass(data.element.className).text(data.placeName);
                const $element = $('<span>').addClass(data.element.className).text(data.placeName);
                return $element;
            }
            if(data.text) {
                const $element = $('<span>').addClass(data.element.className).text(data.text);
                let elemClass;
                switch ( (data.dest).split(':').length ) {
                    case 1: elemClass = 'ps-1 fw-bold'; break;
                    case 2: elemClass = 'ps-3 fw-bold'; break;
                    case 3: elemClass = 'ps-5 '; break;
                    case 4: elemClass = 'ps-5 '; break;
                    default: elemClass = 'h5'; break;
                }
                $element.addClass(elemClass);
                return $element;
            }
        },
    };

    // global init select2
    // data-templates
    // data-data
    // data-allow-clear
    // data-nosearch
    // placeholder
    $.map($('.select2'), elem => {
        const $elem = $(elem);
        const config = { dropdownParent: $elem.parent(), language: language };
        config.allowClear = $elem.attr('data-allow-clear');

        // find select2 which has an attribute data-data
        const data = $elem.attr('data-data');
        if ( data ) {
            try {
                config.data = JSON.parse(data);
            } catch (e) {}
        } 
        else if ( $elem.attr('data-special') ) {
            let newData = $('body').attr('data-select-' + $elem.attr('data-special'));
            config.data = JSON.parse(newData);
        }

        if ( $elem.attr('data-template') ) {
            config.templateResult = selectTemplates[$elem.attr('data-template')];
        }
        if ( $elem.attr('data-template-selection') ) {
            config.templateSelection = selectTemplates[$elem.attr('data-template-selection')];
        }

        if ( $elem.attr('data-nosearch') !== undefined ) {
            config.minimumResultsForSearch = Infinity;
        }

        let placeholder = $elem.attr('placeholder');
        $elem.removeAttr('placeholder');
        config.placeholder = placeholder || ' ';
        
        $elem.select2(config)
            .on('select2:clear', () => {
                $elem[0].cleared = true;
            })
            .on('select2:opening', e => {
                if ( $elem[0].cleared ) {
                    e.preventDefault();
                    $elem[0].cleared = false;
                }
            });
    });
    
    // advanced form controls
    // input-popover
    $('body').on('click', '.dropdown-menu-popover', e => {
        e.stopPropagation();
    });



    $('.nav-collapse').on('click', function(e) {
        let $target = $(this);
        $target.parent().toggleClass('collapse-active', ! $target.hasClass('collapsed'));
    })


   

    function dateDiff(from, to) {
        let f = Date.UTC(from.getFullYear(), from.getMonth()+1, from.getDate());
        let t = Date.UTC(to.getFullYear(), to.getMonth()+1, to.getDate());
    
        return Math.round((from - to) / (1000 * 60 * 60 * 24));
    }


    // itinerary slider (winterijada) — all 5 days fit above 1540px, so no dragging there
    if ( $('#itinerary-slider').length ) {
        new Slider('#itinerary-slider', {
            loop: true,
            arrows: true,
            pager: true,
            rubberband: false,
            autoplay: false,
            pauseOnHover: true,
            drag: false,
            slides: {
                perView: 5,
                spacing: 16
            },
            breakpoints: {
                '(max-width: 1540px)': {
                    drag: true,
                    slides: { perView: 4, spacing: 16 }
                },
                '(max-width: 991px)': {
                    drag: true,
                    slides: { perView: 2, spacing: 12 }
                },
                '(max-width: 575px)': {
                    drag: true,
                    slides: { perView: 1, spacing: 8 }
                }
            }
        });
    }

    // gallery slider (winterijada) — click still opens lightGallery
    if ( $('#gallery-slider').length ) {
        new Slider('#gallery-slider', {
            loop: true,
            pager: true,
            rubberband: false,
            autoplay: 4000,
            pauseOnHover: true,
            slides: {
                perView: 5,
                spacing: 8
            },
            breakpoints: {
                '(max-width: 991px)': {
                    slides: { perView: 2, spacing: 8 }
                },
                '(max-width: 575px)': {
                    slides: { perView: 1, spacing: 8 }
                }
            }
        });
    }
    
});


